var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 5.8335H0.583414M12.2501 2.3335H1.75008C1.10575 2.3335 0.583414 2.85583 0.583414 3.50016V10.5002C0.583414 11.1445 1.10575 11.6668 1.75008 11.6668H12.2501C12.8944 11.6668 13.4167 11.1445 13.4167 10.5002V3.50016C13.4167 2.85583 12.8944 2.3335 12.2501 2.3335Z",
    stroke: "#757575",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/Credit card.002b193b4f438cd85f98650ad25ecada.svg";
export { ForwardRef as ReactComponent };